import { inject, Injectable, signal } from "@angular/core";
import { Http } from "@skylab-angular-shared/core";
import { KsefMonitorStatusNotificatorBase } from "@skylab-shared/business";
import { HttpService, TaggedUrl, Tags } from "@skylab-shared/core";
import { KsefMonitorStatusNotificator } from "../event-notifications/notificators/ksef-monitor-status-notificator.service";

export type KsefEmergencies = {
    started: Date,
    ended?: Date
}

export type KsefMonitorData = {
	isKsefEmergencyActive: boolean;
    emergencies: KsefEmergencies[];
}

@Injectable({providedIn: 'root'})
export class KsefMonitorService {
	readonly #http = inject(Http) as HttpService;
	readonly #ksefMonitorNotificator = inject(KsefMonitorStatusNotificator) as KsefMonitorStatusNotificatorBase;
	readonly #URL = TaggedUrl.join('system/ksef/monitor-status', [Tags.Api]);

    #ksefEmergencyActive = signal(false);
    ksefEmergencyActive = this.#ksefEmergencyActive.asReadonly();

    #ksefEmergencies = signal<KsefEmergencies[]>([]);
    ksefEmergencies = this.#ksefEmergencies.asReadonly();

    constructor() {
        this.#ksefMonitorNotificator.addObserver(e => {
            this.refreshAsync();
        })
    }

    async refreshAsync(): Promise<void> {
        const { data } = await this.#http.get<KsefMonitorData>(this.#URL);
        this.#ksefEmergencyActive.set(data.isKsefEmergencyActive);
        this.#ksefEmergencies.set(data.emergencies);
    }
}